module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v",
    attrs: {
      "id": "result-page"
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    staticClass: "choose-show-cases dialog-choose-show-cases"
  }, [_c('el-checkbox-group', {
    attrs: {
      "size": "large",
      "fill": "#324057",
      "text-color": "#a4aebd",
      "min": 1,
      "max": 3
    },
    model: {
      value: (_vm.compareCasesName),
      callback: function($$v) {
        _vm.compareCasesName = $$v
      },
      expression: "compareCasesName"
    }
  }, _vm._l((_vm.casesEle), function(caseOne) {
    return _c('el-checkbox-button', {
      key: caseOne.name,
      attrs: {
        "label": caseOne.name,
        "disabled": caseOne.status !== 30
      }
    }, [_vm._v(_vm._s(caseOne.name))])
  }))], 1), _vm._v(" "), _c('case-compare-table', {
    attrs: {
      "caseDatas": _vm.compareCases,
      "table_height": 22
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f47382e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/ele/ele_compare.vue
// module id = 954
// module chunks = 1